// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"594248da","103":"2d5db700","255":"ed71a24f","342":"b3103f43","925":"261e3e32"}[chunkId] + ".chunk.js";
};